// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link[data-v-9bb0684a] {\n  font-weight: var(--magic-font-weight-bold, 700);\n  font-size: 1rem;\n  padding: calc(var(--magic-space--small, 8px) + (var(--magic-space--xx-small, 2px) / 4)) 0;\n}", ""]);
// Exports
module.exports = exports;
